import { RouteRecordRaw } from 'vue-router';
import { timerRoutes } from './timer';

export const globalRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('/@pages/NotFoundPage/NotFoundPage.vue'),
    redirect: timerRoutes[0].path,
  },
  {
    path: '/user',
    component: () => import('/@pages/UserProfilePage/UserProfilePage.vue'),
  },
  {
    path: '/notifications',
    component: () => import('/@pages/NotificationPage/NotificationPage.vue'),
    children: [
      {
        path: ':registrationId',
        component: () => import('/@pages/RegistrationItemPage/RegistrationItemPage.vue'),
        meta: { isModal: true },
      },
    ],
  },
  {
    path: '/settings/:tab?',
    component: () => import('/@pages/SettingsPage/SettingsPage.vue'),
    props: ({ params }) => ({
      tab: params.tab,
    }),
  },
  {
    path: '/test',
    component: () => import('/@pages/TestPage/TestPage.vue'),
  },
  {
    path: '/Logout',
    component: () => import('/@pages/LogoutPage/LogoutPage.vue'),
  },
  {
    path: '/callback',
    component: () => import('/@pages/AuthCallback/AuthCallback.vue'),
  },
  {
    path: '/:path(.*)',
    component: () => import('/@pages/NotFoundPage/NotFoundPage.vue'),
  },
];
